<template>
	<div class="outer-box">
		<h4>Get Accounts with StripeId</h4>

		<div class="inner-box" style="text-align: left; width: 600px">
			<input
				class="hl_input--wrap border"
				:class="[isStripeIdEmpty && 'border-danger']"
				type="text"
				placeholder="Stripe ID"
				v-model="stripeId"
			/>
			<p
				v-if="isStripeIdEmpty"
				class="mt-2 text-capitalize"
				:class="[isStripeIdEmpty && 'text-danger']"
			>
				Please Enter Stripe Id
			</p>

			<button
				class="btn btn-success"
				:class="[isStripeIdEmpty ? 'mt-0' : 'mt-5']"
				@click="fetchStripeAccounts"
			>
				<moon-loader
					v-if="processing"
					:loading="true"
					size="21px"
					color="#fafafa"
				/>
				<span v-else>Fetch</span>
			</button>
			<div class="code-wrapper" style="position: relative" v-if="response">
				<pre
					id="text-copy"
					style="background-color: #f2f7fa; padding: 16px; margin-top: 16px"
					>{{ response }}</pre
				>
				<div class="copy-icon">
					<i v-if="!copied" class="far fa-copy" @click="copyText()"></i>
					<p v-else class="text-success">Copied</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { PaymentsService } from "@/services";

export default {
	data() {
		return {
			stripeId: "",
			processing: false,
			response: "",
			isStripeIdEmpty: false,
			copied: false,
		};
	},
	methods: {
		fetchStripeAccounts() {
			this.processing = true;
			PaymentsService.getAccountsWithStripeId(this.stripeId)
				.then((response) => {
					this.response = response.data;
				})
				.catch((error) => {
					this.response = error.message;
				})
				.finally(() => {
					this.processing = false;
				});
		},
		async copyText() {
			const text = document.getElementById("text-copy")?.innerHTML || '';
			return navigator.clipboard
				.writeText(text)
				.then(() => {
					this.copied = true;
					setTimeout(() => {
						this.copied = false;
					}, 2000);
				})
				.catch((err) => {
					console.error(`Error copying text to clipboard: ${err}`);
				});
		},
	},
};
</script>

<style>
</style>
